import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./auth/auth.reducers";
import ebayReducer from "./ebay/ebay.reducers";

/*************************************************/

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  ebay: ebayReducer,
});

/*************************************************/

export default persistReducer(persistConfig, rootReducer);

/*************************************************/
